import { render } from "./EventGeneral.vue?vue&type=template&id=5b9fac1b"
import script from "./EventGeneral.vue?vue&type=script&lang=js"
export * from "./EventGeneral.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__